/**
 * Screen Flow reports listing page.
 */
import { Smartphone, Calendar, Filter, Repeat, Target, Play } from 'lucide-react';
import { ReportsPage } from '@/components/reports/ReportsPage';
import { ConfigBadge } from '@/components/reports/ConfigBadge';
import { PRESET_LABELS } from '@/lib/reports.types';
import { countFilters } from '@/lib/filters';

const iconCls = 'w-3 h-3 shrink-0';

function renderBadges(config: Record<string, unknown>) {
  const preset = (config.preset as string) || '';
  const startDate = (config.start as string) || (config.startDate as string) || '';
  const endDate = (config.end as string) || (config.endDate as string) || '';
  const filterMode = (config.filterMode as string) || 'exclude';
  const events = (config.events as string[]) || [];
  const collapse = Boolean(config.collapse || config.collapseRepeats);
  const kpi = (config.kpi as string) || (config.kpiEvent as string) || '';
  const startFrom = (config.startFrom as string) || (config.startFromEvent as string) || '';
  const filterCount = countFilters(config.filters);

  const dateLabel = preset
    ? PRESET_LABELS[preset] || preset.replace(/_/g, ' ')
    : startDate && endDate
      ? `${startDate} → ${endDate}`
      : '';

  return (
    <>
      {dateLabel && <ConfigBadge icon={<Calendar className={iconCls} />} text={dateLabel} color="amber" />}
      {events.length > 0 && (
        <ConfigBadge
          icon={<Play className={iconCls} />}
          text={`${filterMode === 'include' ? 'Include' : 'Exclude'}: ${events.length} screen${events.length > 1 ? 's' : ''}`}
          color="sky"
        />
      )}
      {collapse && <ConfigBadge icon={<Repeat className={iconCls} />} text="Collapse" color="slate" />}
      {kpi && <ConfigBadge icon={<Target className={iconCls} />} text={`KPI: ${kpi}`} color="violet" />}
      {startFrom && <ConfigBadge icon={<Play className={iconCls} />} text={`From: ${startFrom}`} color="emerald" />}
      {filterCount > 0 && <ConfigBadge icon={<Filter className={iconCls} />} text={`${filterCount} filter${filterCount > 1 ? 's' : ''}`} color="rose" />}
    </>
  );
}

export function ScreenFlowReports() {
  return (
    <ReportsPage
      sectionId="screen_flow"
      sectionRoute="/screen-flow"
      title="Screen Flow"
      subtitle="Track screen-to-screen navigation patterns"
      emptyIcon={Smartphone}
      emptyDescription="Create your first screen flow report to start exploring screen navigation"
      showFolders
      accentColor="emerald"
      cardIcon={<Smartphone className="w-4 h-4 text-emerald-500" />}
      cardIconBgClass="bg-emerald-50"
      renderBadges={renderBadges}
    />
  );
}
